// Third-party libraries
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/pro-solid-svg-icons";

// Types
import { AnswerListOverviewDto } from "../../../../types/CompanyAnswersTypes";

// UI elements
import Alert from "../../../../ui-elements/Alert/Alert";
import DisplayBox from "../../../../ui-elements/DisplayBox/DisplayBox";

// Utilities
import { insertDash, getTableDate, getTimeFromDate } from "../../../../services/utils";
import Link from "../../../../ui-elements/Link/Link";
import { getFileIcon } from "../../../../ui-elements/FileUploadDropZone/FileUploadDropZone";
import { getIndividualQuestionDescription } from "../Constants";


interface IProps {
    data: AnswerListOverviewDto | null;
    answerListIndex: number;
}
const IndividualAnswers: React.FC<IProps> = ({ data, answerListIndex }) => {
    const userFiles = data?.answerLists[answerListIndex].userFiles || [];

    const renderAnswer = (isWrong: boolean, answerBoolean: boolean | null, answerText: string, content?: JSX.Element) => {
        let text = '';
        if (answerBoolean) text = 'Já';
        else if (answerBoolean === false) text = 'Nei';

        if (answerText?.length > 0) {
            if (text === '') {
                text = answerText;
            } else {
                text = text + ', ' + answerText;
            }
        }
        return (
            <div className="answer-wrapper">
                <div className="answer-wrapper__text">
                    {isWrong &&
                        <FontAwesomeIcon className="fa-icon" icon={faCircleExclamation} />
                    }
                    <p className="paragraph-small--bold answer-text">
                        {text}
                    </p>
                </div>
                {content && <div className="answer-wrapper__content">
                    {content}
                </div>}
            </div>
        );
    }

    const getText = () => {
        return data?.answerLists[answerListIndex].userELoginTimestamp
            ? `svaraði þessari könnun með rafrænni innskráningu á island.is þann 
                ${getTableDate(data?.answerLists[answerListIndex].userELoginTimestamp, 'DD/MM/YYYY', '.')} 
                kl. ${getTimeFromDate(data?.answerLists[answerListIndex].userELoginTimestamp, 'HH:MM:SS')} `
            : `svaraði þessari könnun þann 
                ${getTableDate(data?.answerLists[answerListIndex].finishedTimestamp, 'DD/MM/YYYY', '.')} 
                kl. ${getTimeFromDate(data?.answerLists[answerListIndex].finishedTimestamp, 'HH:MM:SS')} `
    }
    const getExpandedText = () => {
        return data?.answerLists[answerListIndex].audkenniTrackId ?
            <div>
                <p>
                    Track ID: {data?.answerLists[answerListIndex].audkenniTrackId}<br />
                    Veitt af: Auðkenni hf.<br />
                </p>
            </div> : undefined
    }
    const getHeadText = () => {
        if (data?.answerLists[answerListIndex].userSSN)
            return `${data?.answerLists[answerListIndex].userName}, kt. ${insertDash(data?.answerLists[answerListIndex].userSSN ?? '')}`;
        else
            return `${data?.answerLists[answerListIndex].userName}`;
    }
    return <>
        <DisplayBox
            id="company-answers"
            title={"Svör við áreiðanleikakönnun"}
        >
            <div className="content">
                <Alert
                    type={"success"}
                    headText={getHeadText()}
                    text={getText()}
                    expandedText={getExpandedText()} />
                <div className="answers-wrapper">
                    <div className="answers-header">
                        <h5 id="questions-overview">Spurningar</h5>
                        <h5 id="answers-overview">Svör</h5>
                    </div>
                    {/* Map through all answers except the last one using slice(0, -1) */}
                    {data?.answerLists[answerListIndex].answers
                        .slice(0, -1) // Remove the last question from the list
                        .map((item, index) => (
                            <div key={index} className='question-item'>
                                <div className="question-content">
                                    {/* Display the question number */}
                                    <p className="paragraph-small--bold question-index">{item.order}.</p>
                                    <div className="question-texts">
                                        {/* Display the question text */}
                                        <p className="paragraph-small--bold question-title">{item.question}</p>
                                        {/* Display optional question description if it exists */}
                                        {getIndividualQuestionDescription(item.order, data.serviceCompanyName) && (
                                            <p className="paragraph-small--italic question-description">
                                                {getIndividualQuestionDescription(item.order, data.serviceCompanyName)}
                                            </p>
                                        )}
                                    </div>
                                </div>
                                {/* Special handling for question 5: display beneficial owner info */}
                                {/* For all other questions: display the regular answer text */}
                                {item.order === 5
                                    ? renderAnswer(
                                        item.isWrong,
                                        item.answerBoolean,
                                        // Combine name and ssn with separator, filtering out empty values
                                        [item.beneficialOwner?.name, item.beneficialOwner?.ssn]
                                            .filter(Boolean)
                                            .join(' - ')
                                    )
                                    : renderAnswer(
                                        item.isWrong,
                                        item.answerBoolean,
                                        item.answertext
                                    )
                                }
                            </div>
                        ))}
                </div>
                {userFiles && userFiles.length > 0 &&
                    (
                        <div className="uploaded-file-list">
                            <h5>Fylgiskjöl</h5>
                            {userFiles.map((file, index) => (
                                <div className='uploaded-file-list__item' key={index}>
                                    <div className='uploaded-file-list__item--left-section'>
                                        <p className='file-item__index'>{index + 1}.</p>
                                        <Link url={`/DueDiligence/GetFile/${file.id}`} icon={getFileIcon(file.fileExtensionType)} className='uploaded-file-list__name'>
                                            {file.encodedFileName}
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )
                }
            </div>
        </DisplayBox>
    </>
}
export default IndividualAnswers;